import React from 'react';
import { Box } from '@material-ui/core';
import { SchemaRenderer } from '../schema-renderer';
import { ComponentSchema } from '../schema-types';

interface ColumnLayoutProps {
  columns: Array<{
    width?: string | number;
    className?: string;
    component?: ComponentSchema;
    children?: ComponentSchema[];
  }>;
  gap?: string | number;
  alignItems?: 'start' | 'center' | 'end' | 'stretch';
  className?: string;
  style?: React.CSSProperties;
  responsive?: boolean;
  // Props passed from schema renderer
  data?: any;
  baseData?: any;
  player?: any;
  playerAssessment?: any;
  context?: any;
}

export const ColumnLayout: React.FC<ColumnLayoutProps> = ({
  columns,
  gap = '1rem',
  alignItems = 'center',
  className,
  style,
  responsive = true,
  data,
  baseData,
  player,
  playerAssessment,
  context
}) => {
  const alignValue = alignItems === 'start' ? 'flex-start' :
                     alignItems === 'end' ? 'flex-end' :
                     alignItems === 'stretch' ? 'stretch' :
                     alignItems;

  return (
    <Box
      display="flex"
      flexDirection={responsive ? { xs: 'column', md: 'row' } : 'row'}
      alignItems={alignValue}
      style={{ gap, ...style }}
      className={className}
    >
      {columns.map((column, index) => (
        <Box
          key={index}
          className={column.className}
          style={{
            flex: column.width ? `0 0 ${column.width}` : '1 1 0%',
            minWidth: 0,
            width: responsive ? '100%' : undefined
          }}
        >
          {column.component && (
            <SchemaRenderer
              schema={column.component}
              data={data}
              baseData={baseData}
              player={player}
              playerAssessment={playerAssessment}
              context={context}
            />
          )}
          {column.children && column.children.map((child, childIndex) => (
            <SchemaRenderer
              key={childIndex}
              schema={child}
              data={data}
              baseData={baseData}
              player={player}
              playerAssessment={playerAssessment}
              context={context}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
};
